import MenuBar from './MenuBar';
export { OVERVIEW_TAB_INDEX, STACKED_DAILY_TAB_INDEX } from './MenuBar';

export default MenuBar;
